var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7635 30.9922C59.6547 41.5462 50.0774 49.2332 38.7445 49.2332C27.4117 49.2332 17.8344 41.5462 14.7256 30.9922C14.0345 33.3383 13.6631 35.8261 13.6631 38.4026C13.6631 52.5695 24.8924 64.0541 38.7445 64.0541C52.5966 64.0541 63.826 52.5695 63.826 38.4026C63.826 35.8261 63.4545 33.3383 62.7635 30.9922Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.9203,
    cy: 37.9203,
    r: 35.9203,
    stroke: "white",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonIcon);
export default __webpack_public_path__ + "static/media/moonIcon.fc5ee73858da29417a764fd5fe14531b.svg";
export { ForwardRef as ReactComponent };